export var version = '1.19.6';